import { Outlet } from "react-router-dom";
import { AppSidebar } from "./AppSidebar";
import { PageFrame } from "./PageFrame";
import {
    ResizableHandle,
    ResizablePanel,
    ResizablePanelGroup
} from "@/components/ui/resizable";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { ErrorBoundary } from "@/frontend/@error/ErrorBoundary";
import { LoadingBoundary } from "@/frontend/@ui/LoadingBoundary";

export const Template = () => {
    return (
        <SidebarProvider>
            <div className="flex w-full md-not-print:h-screen">
                <ResizablePanelGroup
                    direction="horizontal"
                    autoSaveId="AppSidebar"
                    className="contents md-not-print:flex"
                    style={{ display: undefined }} // don't let resizable set display property
                >
                    <ResizablePanel
                        className="relative hidden min-w-[200px] md-not-print:block"
                        minSize={10}
                        defaultSize={16}
                        maxSize={50}
                    >
                        <AppSidebar />
                    </ResizablePanel>
                    <ResizableHandle />
                    <ResizablePanel className="contents md-not-print:relative md-not-print:block">
                        <SidebarInset className="@container">
                            <ErrorBoundary
                                fallbackWrapper={children => (
                                    // ensure mobile open nav button is visible, even if an error has triggered
                                    <PageFrame breadcrumbReplacement={<></>}>
                                        {children}
                                    </PageFrame>
                                )}
                            >
                                {/* page content loading boundary */}
                                <LoadingBoundary absolute={true}>
                                    <Outlet />
                                </LoadingBoundary>
                            </ErrorBoundary>
                        </SidebarInset>
                    </ResizablePanel>
                </ResizablePanelGroup>
            </div>
        </SidebarProvider>
    );
};
